import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { Button, Space, Tabs } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { magpCMSApi } from "~/Services";
import { CPOsOffice } from "./CPOsOffice/CPOsOffice";
import { DynamicView } from "./DynamicCD/View";

export const ContractDirectory = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [tabs, setTabs] = useState([]);

  const getRecords = () => {
    setIsLoading(true);
    let url = `/api/get-contact-directory-departments/all-fields`;
    magpCMSApi
      .get(url)
      .then((res: any) => {
        if (res && res.data) {
          let tabslist = res.data;
          setTabs(tabslist);
          console.log("tabslist", tabslist);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setTabs([]);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getRecords();
  }, []);

  const approveQuery = new URLSearchParams(location.search);
  const approveId = approveQuery.get("id");

  useEffect(() => {
    if (approveId) {
      return;
    }
    if (!query.get("activeTab")) {
      navigate(`/dedicated/magp/contact-directory?activeTab=CposOffice`, {
        replace: true,
      });
    }
  }, []);

  const items = [
    {
      label: "CPOs OFFICE",
      key: "CposOffice",
      children: <CPOsOffice />,
    },
    ...tabs.map((tab: any) => ({
      label: tab?.name,
      key: tab?.name,
      children: <DynamicView config={tab} />,
    })),
  ];

  const handleProductManagement = (activeTab: any) => {
    return (
      <Space>
        {activeTab != "CposOffice" && (
          <Button
            onClick={() => {
              navigate(`/dedicated/magp/contact-directory/${activeTab}/add?contactDirKey=${activeTab}`);
            }}
            icon={<Icon icon={"lucide:plus"} />}
          >
            {`Add New ${activeTab}`}
          </Button>
        )}
        <Button
          onClick={() => {
            navigate(`/dedicated/magp/contact-directory/add`);
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          {`Add New Contact Directory`}
        </Button>
        <Button
          onClick={() => {
            navigate(`/dedicated/magp/contact-directory/edit`);
          }}
        >{`Edit Contact Directory`}</Button>
      </Space>
    );
  };

  return (
    <ContentWrapper
      title={"Contact Directory"}
      actionItems={handleProductManagement(query.get("activeTab"))}
    >
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey}`);
        }}
      ></Tabs>
    </ContentWrapper>
  );
};
